import { render, staticRenderFns } from "./ConvertQueueDialog.vue?vue&type=template&id=06b88851&scoped=true"
import script from "./ConvertQueueDialog.vue?vue&type=script&lang=js"
export * from "./ConvertQueueDialog.vue?vue&type=script&lang=js"
import style0 from "./ConvertQueueDialog.vue?vue&type=style&index=0&id=06b88851&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b88851",
  null
  
)

export default component.exports